import React from "react";
import CardDetailTopComponent from "./CardDetailTopComponent";
import HeaderComponent from "../HeaderComponent";
import BackgroundAndTextComponent from "../BackgroundAndTextComponent";
import { Paper } from "@mui/material";

const CardDetailsComponent = () => {
  return (
    <>
      <HeaderComponent />
      <BackgroundAndTextComponent />
      <div className="container mt-5">
        <Paper style={{ backgroundColor: "#a6a6a6", padding: 5 }}>
          <CardDetailTopComponent />
        </Paper>
      </div>
    </>
  );
};

export default CardDetailsComponent;
